import type { ReactNode } from 'react';

interface ContainerProps {
  maxWidth?: 'content' | 'text';
  children: ReactNode;
}

export function Container({ maxWidth = 'content', children }: ContainerProps) {
  return (
    <div
      style={{
        maxWidth:
          maxWidth === 'content'
            ? 'var(--content-max-width)'
            : 'var(--text-max-width)',
        margin: '0 auto',
        padding: '0 var(--spacing-md)',
      }}
    >
      {children}
    </div>
  );
}
